import React, { Component } from "react";
import FormCore from "@/components/display/form/formCore";
import GridTable from "@/components/display/table/gridTableCore";
import { Modal, Button, message } from "antd";
import {
  getModelNoList,
  getFrameWorkList,
  getUpdateTypeList,
  getStubInfoList,
  getCityList,
  prefixFile,
  stubRestart,
} from "@/fetch/fetchApi";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import StubStruts from "@/utils/stubStruts";
import fetchHandler from "../../../fetch/fetchHandler";
import RefreshGrid from "../../../utils/refreshGrid";
import StubDetailInfo from "./stubDetailInfo";
import StubStatusUpdate from "./stubStatusUpdate";
import StubParamsConfig from "./stubParamsConfig";
import FrameWorkUpdate from "./frameWorkUpdate";
import GetFrameWorkEdition from "./getFrameWorkEdition";
import StubStatusLog from "./stubStatusLog";
import UpdateProgress from "./updateProgress";

// 国际化切换语言

/**
 * 引入设备状态列表
*/

// const TabPane = Tabs.TabPane;

// eslint-disable-next-line arrow-parens
@connect(state => state)
class StubList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.stubList;
    this.yunwei = this.props.intl.messages.commonBase;
    this.init();
    this.isFirst = true;
    this.hasSearch = false;
    this.state = {
      data: [],
      pagination: {},
      loading: false,
      visible: false,
      xhList: [],
      formConfig: null,
      stubInfoData: null,
      tableParam: {
        stubGroupName: this.queryStubName,
        // stubGroupId:this.queryStubGroupId,
        meterModuleId: this.queryMeterModuleId,
        stubId: this.queryStubId,
      },
      typeOption: [{
        text: this.props.intl.messages.commonBase.wz10, // '全部',
        value: "",
      }],
      currentParam: {},
    };
  }

  /**
     * 页面加载前调用方法，初始化查询form表单
     */
  componentWillMount() {
    /**
         * 设备状态定义
         */
    this.stateOption = StubStruts();
    /**
         * 初始化form查询表单
         */
    this.setState({
      formConfig: this.initFormConfig(),
    });
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    };

    /**
     * 页面加载完成调用方法，表格数据加载，并且初始化值
     */
    componentDidMount() {
      this.fetchApi(this.state.tableParam);
      this.setState({
        stubGroupName: "",
        meterModuleId: "",
        stubId: "",
        tableParam: {
          stubGroupName: "",
          stubGroupId: "",
          meterModuleId: "",
          stubId: "",
        },
      });
    }

    /**
     * 查询form表单初始化
     */
    initFormConfig = () => {
      // 运营类型定义
      const option1 = [{
        text: this.yunwei.wz10, // '全部',
        value: "",
      }, {
        text: this.yunwei.wz3, // '星充直营',
        value: "2",
      }, {
        text: this.yunwei.wz4, // '加盟直营',
        value: "3",
      }, {
        text: this.yunwei.wz5, // '联营',
        value: "1",
      }, {
        text: this.yunwei.wz6, // '他营',
        value: "0",
      }, {
        text: this.yunwei.wz7, // '人人电站',
        value: "5",
      }];

      const option2 = [{
        text: this.yunwei.wz10, // '全部',
        value: "",
      }, {
        text: this.yunwei.wz8, // '私桩',
        value: "0",
      }, {
        text: this.yunwei.wz9, // '非私桩',
        value: "1",
      }];

      const option3 = [{
        text: this.yunwei.wz10, // '全部',
        value: "",
      }];

      const formConfig = {
        childItems: [
          {
            type: "input",
            placeholder: this.internationalization.placeholder1, // .'请输入设备编号',
            param: {
              name: "stubId",
              type: "string",
            },
            defaultValue: this.queryStubId,
            labelName: this.internationalization.title1, // '设备编号:',
            required: false,
          },
          {
            type: "input",
            placeholder: this.internationalization.placeholder2, // '请输入电站名称',
            param: {
              name: "stubGroupName",
              type: "string",
            },
            defaultValue: this.queryStubName,
            labelName: this.internationalization.title2, // '电站名称:',
            required: false,
          }, {
            type: "areaPicker",
            isPickArea: !0,
            placeholder: this.internationalization.title8, // '请选择地区',
            pickOnSelect: true,
            param: {
              name: "cityId", // 与form表单绑定的参数名
              type: "array",
            },
            required: !1,
            labelName: this.internationalization.wz9, // '地区',
            className: "allshow",
            sourceApi: getCityList,
            mapKey: {
              label: "label",
              value: "value",
              children: "children",
            },
          },
          {
            type: "input",
            placeholder: this.internationalization.wz1, // '请输入配电柜编号',
            param: {
              name: "meterModuleId",
              type: "string",
            },
            defaultValue: this.queryMeterModuleId,
            labelName: this.internationalization.wz2, // '配电柜编号',
            required: false,
          },
          {
            type: "autoWatch",
            placeholder: this.internationalization.title10, // '请选择:',
            param: {
              name: "modelNo",
              type: "string",
            },
            labelName: this.internationalization.title11, // '设备型号',
            required: !1,
            sourceApi: getModelNoList,
          },
          {
            type: "inputGroup",
            isArray: true,
            inputGroup: [{
              type: "select",
              placeholder: this.internationalization.title15, // '固件型号:',
              width: "95px",
              param: {
                name: "updateType",
                type: "string",
              },

              labelName: this.internationalization.wz3, // '固件信息','固件信息:',
              dataApi: { api: getUpdateTypeList, loaded: !1, addAll: true },
              required: false,
              onChange: async (value, form) => {
                form.setFieldsValue({
                  frameWork: "",
                  updateType: value,
                });
                fetchHandler(getFrameWorkList, {
                  updateType: value,
                }).then((res) => {
                  const finalData = res.data;
                  finalData.unshift("全部");
                  this.setState({
                    xhList: finalData.map((v) => {
                      return {
                        text: v,
                        value: v,
                      };
                    }),
                  }, () => {
                    this.setState({
                      formConfig: this.initFormConfig(),
                    });
                  });
                });
              },
            },
            {
              type: "select",
              placeholder: this.internationalization.title13, // '固件版本:',
              width: "95px",
              param: {
                name: "frameWork",
                type: "string",
              },
              options: this.state.xhList,
              required: false,
            }],
          },
          {
            type: "select",
            options: [{
              text: this.yunwei.wz10, // '全部',
              value: "",
            }, {
              text: this.internationalization.title20, // '交流电',
              value: "0",
            }, {
              text: this.internationalization.title21, // '直流电',
              value: "1",
            }, {
              text: this.internationalization.title22, // '交直流',
              value: "2",
            }],
            placeholder: this.internationalization.title8, // '请选择设备类型',
            param: {
              name: "stubType",
              type: "string",
            },
            labelName: this.internationalization.title19, // '设备类型',
            required: false,
          },

          {
            type: "inputGroup",
            isArray: true,
            inputGroup: [{
              type: "select",
              width: "95px",
              options: [{
                text: this.yunwei.wz10, // '全部',
                value: "",
              }, {
                text: this.yunwei.wz1, // '运营',
                value: "1",
              }, {
                text: this.yunwei.wz2, // '运维',
                value: "0",
              }],
              placeholder: this.internationalization.title8, // '请选择',
              param: {
                name: "operationProperty",
                type: "string",
              },
              labelName: this.yunwei.wz0, // '运营类型:',
              required: false,
              onChange: (value, form) => {
                form.setFieldsValue({
                  operationProperty: value,
                  operationMode: "",
                });
                console.log(value);
                const stubType2List = [];
                if (value === "0") {
                  stubType2List.push(...option2);
                } else if (value === "1") {
                  stubType2List.push(...option1);
                } else if (value === "") {
                  stubType2List.push(...option3);
                }
                this.setState({
                  typeOption: [...stubType2List],
                }, () => {
                  this.setState({
                    formConfig: this.initFormConfig(),
                  });
                });
              },
            },
            {
              type: "select",
              width: "95px",
              dropdownMatchSelectWidth: 250,
              placeholder: this.internationalization.title8, // '请选择',
              param: {
                name: "operationMode",
                type: "string",
              },
              labelName: "",
              options: this.state.typeOption,
              required: false,
            }],
          },
          {
            type: "select",
            placeholder: this.internationalization.title8, // '请选择设备状态',
            labelName: this.internationalization.title27, // '设备状态',
            param: {
              name: "stubStatus",
              type: "string",
            },
            options: this.stateOption,
            required: false,
          },
          {
            type: "input",
            placeholder: "请输入iccid卡号", // .'请输入设备编号',
            param: {
              name: "iccid",
              type: "string",
            },
            labelName: "iccid卡号", // '设备编号:',
            required: false,
          },

          {
            type: "buttonGp", // 表单最终执行组
            buttonArr: [
              {
                btnType: "submit",
                // icon: 'search',
                text: this.internationalization.title16, // '查询'
              },
              {
                btnType: "button",
                text: this.internationalization.btn8, // 导出
                handler: (e, param) => {
                  this.exportData(param);
                },
              },
            ],
          },
        ],
        layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
        formTarget: "submit", // 表单提交类型，设置grid则为更新grid
        autoLoadGrid: !0, // 设置为false不触发加载grid
        defaultParams: {
          // stubGroupName: this.queryStubName,
          // powerBoxId: localStorage.meterModuleId,
          meterId: this.queryMeterModuleId,
          stubId: this.queryStubId,
        },

        context: this,
        tableKey: "stubSearchTable",
        tablePage: "设备快速查询",
      };
      return formConfig;
    }

    // 数据导出
    exportData = (param) => {
      const excelUrl = `${prefixFile}/exportStubInfo.do`;

      param.locale = this.props.intl.locale;

      if (param.updateType === this.yunwei.wz10) {
        param.updateType = "";
      }

      if (param.frameWork === this.yunwei.wz10) {
        param.frameWork = "";
      }
      // 城市id格式化
      param.cityId = param.cityId === undefined ? "" : param.cityId.toString().slice(param.cityId.toString().lastIndexOf(",") + 1, param.cityId.toString().length);

      if (param.stubGroupName === this.queryStubName && !this.hasSearch) {
        param.stubGroupId = this.queryStubGroupId;
      } else {
        param.stubGroupId = "";
      }

      let params = "";
      Object.keys(param).forEach((key) => {
        if (param[key] !== undefined) {
          params += `${key}=${param[key]}&`;
        }
      });
      const ele = document.createElement("a");
      ele.download = encodeURI(`${excelUrl}?${params}`);
      ele.style.display = "none";
      ele.href = encodeURI(`${excelUrl}?${params}`);
      ele.target = "_blank"; // 针对 ie模式 的浏览器
      // 触发点击
      document.body.appendChild(ele);
      ele.click();
      // 然后移除
      document.body.removeChild(ele);
    }

    /**
     *
     * 表格初始化
     */
    init = () => {
      this.queryStubId = "";
      this.queryStubName = "";
      this.queryStubGroupId = "";
      this.queryMeterModuleId = "";

      if (window.LayoutTab && window.LayoutTab.tabParam) {
        this.queryStubId = window.LayoutTab.tabParam.stubId ? window.LayoutTab.tabParam.stubId : "";
        this.queryStubName = window.LayoutTab.tabParam.StubName ? window.LayoutTab.tabParam.StubName : "";
        this.queryStubGroupId = window.LayoutTab.tabParam.stubGroupId ? window.LayoutTab.tabParam.stubGroupId : "";
        this.queryMeterModuleId = window.LayoutTab.tabParam.meterModuleId ? window.LayoutTab.tabParam.meterModuleId : "";
      }

      this.tableConfig = {
        tableKey: "stubSearchTable",
        tableColumns: [
          {
            name: this.internationalization.title1, // '设备编号',
            key: "key",
            colType: "textCol",
            align: "left",
            width: 200,
          }, {
            name: this.internationalization.title18, // '所属电站',
            key: "stubGroupName",
            colType: "tipCol",
            align: "left",
            width: 200,
          }, {
            name: "地区",
            key: "cityName",
            colType: "textCol",
            align: "left",
            width: 200,
          }, {
            name: this.internationalization.title19, // '设备类型'
            key: "type",
            align: "left",
            width: 200,
            colType: "textCol",
            render: (value) => {
              switch (value) {
                case 0:
                  return this.internationalization.title20;// '交流电';
                case 1:
                  return this.internationalization.title21;// '直流电';
                case 2:
                  return this.internationalization.title22;// '交直流';
                default:
                  return this.internationalization.title23;// '未知'
              }
            },

          },
          {
            name: this.yunwei.wz0, // '运营类型',
            key: "operationMode",
            colType: "textCol",
            align: "left",
            width: 200,
            render: (value, row) => {
              if (row.operationProperty.toString() === "1") {
                if (value.toString() === "0") {
                  return (<div>{this.yunwei.wz1}-{this.yunwei.wz6}</div>);
                } else if (value.toString() === "1") {
                  return (<div>{this.yunwei.wz1}-{this.yunwei.wz5}</div>);
                } else if (value.toString() === "2") {
                  return (<div>{this.yunwei.wz1}-{this.yunwei.wz3}</div>);
                } else if (value.toString() === "3") {
                  return (<div>{this.yunwei.wz1}-{this.yunwei.wz4}</div>);
                } else if (value.toString() === "5") {
                  return (<div>{this.yunwei.wz1}-{this.yunwei.wz7}</div>);
                } else {
                  return (<div>--</div>);
                }
              } else if (row.operationProperty.toString() === "0") {
                if (value.toString() === "0") {
                  return (<div>{this.yunwei.wz2}-{this.yunwei.wz8}</div>);
                } else if (value.toString() === "1") {
                  return (<div>{this.yunwei.wz2}-{this.yunwei.wz9}</div>);
                } else if (value.toString() === "2") {
                  return (<div>--</div>);
                }
              } else {
                return "--";
              }
            },
          }, {
            name: this.internationalization.title24, // '设备型号',
            key: "modelNo",
            colType: "textCol",
            align: "left",
            width: 200,
          }, {
            name: this.internationalization.wz3, // '固件信息',
            key: "updateType",
            colType: "textCol",
            align: "left",
            width: 200,
            render: (value, row) => {
              if (value === "--") {
                return "--";
              } else {
                return `${value}-${row.frameWork}`;
              }
            },
          }, {
            name: this.internationalization.title27, // '设备状态',
            key: "statusName",
            colType: "textCol",
            align: "left",
            width: 200,
            render: (text, res) => {
              return (
                <div>{text} {text === "升级中"
                  ? <a
                      onClick={() => {
                        this.stubInfoData = res;
                        this.setState({
                          progressVisible: true,
                        });
                      }}>进度
                    </a> : null}
                </div>
              );
            },
          }, {
            name: "iccid卡号", // 'iccid卡号',
            key: "iccid",
            colType: "textCol",
            align: "left",
          }, {
            name: "托管到期时间", // 'iccid卡号',
            key: "enableEndDate",
            colType: "textCol",
            align: "left",
          }, {
            name: this.internationalization.action, // '操作',
            key: "action",
            fix: "right",
            width: 320,
            colType: "action",
            actionMap: [
              // {
              //     type: 'href',
              //     actionName: '实时状态',
              //     render: (text, res) => {
              //         //return res.status === '已完成' ?
              //  null : (res.status === '已处理' ? null : '填写跟进人');
              //     },
              //     handler: (res) => {
              //     }
              // },
              {
                type: "href",
                actionName: this.internationalization.wz5, // '配置信息',
                handler: (record) => {
                  this.setState({
                    seeParamsConfigVisible: true,
                    stubId: record.key,
                    stubGroupName: record.stubGroupName,
                    devType: record.type,
                  });
                },
              },
              // {
              //     type: 'href',
              //     actionName: '设备详情',
              //     handler: (res) => {
              //         this.stubInfoData = res;
              //         this.modalVisibleAction('seeDetailVisible',true);
              //         this.setState({
              //             seeDetailVisible : true
              //         })
              //     }
              // },
              {
                type: "href",
                actionName: this.internationalization.btn4, // '基础信息',
                handler: (res) => {
                  this.openTab({
                    stubId: res.key,
                  }, {
                    key: "stubBasicInfo",
                    titleText: this.internationalization.btn4,
                  });
                  this.stubInfoData = res;
                  // this.modalVisibleAction('seeDetailVisible', true);
                  // this.setState({
                  //     seeDetailVisible: true
                  // })
                },
              }, {
                type: "href",
                actionName: this.internationalization.wz6, // '模块信息',
                handler: (record) => {
                  this.openTab({
                    keyId: `moduleInfo${record.key}`,
                    stubId: record.key,
                  }, {
                    key: "moduleInfo",
                    titleText: this.internationalization.wz6, // '模块信息',
                  });
                },
              }, {
                type: "href",
                actionName: this.internationalization.btn5, // '订单信息',
                handler: (record) => {
                  this.openTab({
                    keyId: "0501",
                    stubInfoData: record,
                  }, {
                    key: "0501",
                    titleText: this.internationalization.btn5, // '订单信息',
                  });
                },
              }, {
                type: "href",
                actionName: this.internationalization.btn2, // '修改状态',
                handler: (record) => {
                  this.setState({
                    seeStubStatusVisible: true,
                    stubId: record.key,
                    isBatch: null,
                  });
                },
              },
              {
                type: "href",
                actionName: "固件升级",
                render: (record) => {
                  return record.statusName === "升级中" ? null : "固件升级";
                },
                handler: (record) => {
                  this.stubInfoData = record;
                  this.setState({
                    updateStatus: null,
                    frameWorkUpdateVisible: true,
                    stubId: record.key,
                    frameType: record.updateType,
                    frameWork: record.frameWork,
                    isBatch: null,
                  });
                },
              },
              {
                type: "href",
                actionName: "状态日志",
                handler: (record) => {
                  this.stubInfoData = record;
                  this.modalVisibleAction("statusLogVisible", true);
                },
              },
              {
                type: "confirm",
                actionName: "远程复位",
                handler: (record) => {
                  fetchHandler(stubRestart, {
                    stubId: record.key,
                  }).then((res) => {
                    if (res && (res.code === "ok" || res.code === "success")) {
                      message.success("远程复位成功");
                    }
                  });
                },
              },
              // {
              //     type: 'href',
              //     actionName: '获取固件版本',
              //     handler: (record) => {
              //         this.setState({
              //             getFrameWorkVisible:true,
              //             stubId: record.key,
              //             isBatch: null
              //         })
              //     }
              // },{
              //     type: 'href',
              //     actionName: '固件升级',
              //     handler: (record) => {
              //         this.setState({
              //             frameWorkUpdateVisible:true,
              //             stubId: record.key,
              //             frameType : record.updateType,
              //             isBatch: null
              //         })
              //     }
              // }
              // ,{
              //     type: 'href',
              //     actionName: '命令下发',
              //     render: (text, res) => {
              //         //return res.status === '已完成' ?
              // null : (res.status === '已处理' ? null : '填写跟进人');
              //     },
              //     handler: (res) => {
              //     }
              // }

            ],
          },
        ],
        tableParam: {
          pageCount: 10,
        },
        dataApi: getStubInfoList,
        autoRefresh: !1, // 设置为true 直接加载grid数据
      };
    }

    /**
     * 页面内调用，关闭modal弹窗方法
    */
    modalVisibleAction(modalVisibleKey, visible) {
      this.setState({
        [modalVisibleKey]: visible,
      });
    }

    /**
     * 传递给modal弹窗内组件子方法，关闭modal弹窗方法
    */
    cancelModal(key) {
      this.setState({
        [key]: false,
      });
    }

    /**
     * 新开tab页方法
     */
    openTab = (param, e) => {
      this.props.onAdd(e, param);
      // this.props.handle && this.props.handle()
    };

    /**
     * 表格数据加载方法
     */
    fetchApi = (param) => {
      const newParam = param;

      if (newParam.updateType === this.yunwei.wz10) {
        newParam.updateType = "";
      }

      if (newParam.frameWork === this.yunwei.wz10) {
        newParam.frameWork = "";
      }

      // 城市id格式化
      newParam.cityId = newParam.cityId === undefined ? "" : newParam.cityId.toString().slice(newParam.cityId.toString().lastIndexOf(",") + 1, newParam.cityId.toString().length);

      if (this.isFirst) {
        this.isFirst = false;
        newParam.stubGroupId = this.queryStubGroupId;
      } else {
        this.hasSearch = true;
        newParam.stubGroupId = "";
        param.stubGroupId = "";
      }
      this.setState({
        tableParam: param,
      });
      console.log(this.isFirst);
      console.log(newParam);
      // 当设置formTarget为grid时，执行自定义提交事件。
      if (this.state.formConfig.formTarget === "grid") {
        return;
      }
      // 请求fetch 对象，带入生成参数
      // 如果在modal中的表单提交，请执行这里
      if (this.props.modalSubmit) {
        return this.props.modalSubmit(newParam);
      } else {
        this.setState({
          currentParam: newParam,
        });
        // 如果正常页面中的表单提交，请执行下面
        return RefreshGrid(this.context.store, "stubSearchTable", newParam);
      }
    }

    // 更新frameType
    updateFramType = () => {
      console.log(12333);
      fetchHandler(getStubInfoList, {
        stubId: this.stubInfoData.key,
      }).then((res) => {
        if (res && (res.code === "success" || res.code === "ok")) {
          this.setState({
            frameType: res.data[0].updateType,
            frameWork: res.data[0].frameWork,
          });
        }
      });
    }

    render() {
      const Content = <div className="sc-page-content">
        <div className="page-toolbar">
          <FormCore formConfig={this.state.formConfig} fetchApi={this.fetchApi} />
        </div>
        <div className="page-panel">
          <GridTable config={this.tableConfig} />
        </div>

        {/* <Modal  title="电桩详情"
        visible={this.state.seeDetailVisible}
        footer={null} destroyOnClose={true} */}
        {/*        width={'1000px'} */}
        {/*        onCancel = {()=>{this.modalVisibleAction('seeDetailVisible',false)} }> */}
        {/*    <StubDetailInfo stubInfoData={this.stubInfoData}/> */}
        {/* </Modal> */}

        {/* <Modal  title="电桩详情"
        visible={this.state.seeDetailVisible} footer={null} destroyOnClose={true} */}
        {/*        width={'1000px'} */}
        {/*        onCancel = {()=>{this.modalVisibleAction('seeDetailVisible',false)} }> */}
        {/*    <StubOrderInfo params={this.stubInfoData}/> */}
        {/* </Modal> */}

        <Modal
          title={this.internationalization.btn4}
          visible={this.state.seeDetailVisible}
          footer={null}
          destroyOnClose
          width="1000px"
          onCancel={() => { this.modalVisibleAction("seeDetailVisible", false); }}>
          {/* <Tabs type="card">
                    <TabPane tab="基础信息" key="stubDetailInfo">
                        <StubDetailInfo stubInfoData={this.stubInfoData}/>
                    </TabPane>
                    <TabPane tab="模块信息" key="moduleInfo">
                        <ModuleInfo />
                    </TabPane>
                    <TabPane tab="订单信息" key="stubOrderInfo">
                        <StubOrderInfo  params={this.stubInfoData} onAdd={this.props.onAdd}
                                        cancelModal={() => {this.cancelModal('seeDetailVisible')}}/>
                    </TabPane>
                </Tabs> */}

          <StubDetailInfo
            stubInfoData={this.stubInfoData}
            refreshGrid={() => {
              this.fetchApi(this.state.tableParam);
            }} />
        </Modal>

        <Modal
          title={this.internationalization.btn6}
          visible={this.state.seeStubStatusVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => { this.modalVisibleAction("seeStubStatusVisible", false); }}>
          <StubStatusUpdate
            stubId={this.state.stubId}
            onCancel={() => {
              this.setState({ seeStubStatusVisible: false });
            }}
            refreshGrid={() => {
              RefreshGrid(this.context.store, "stubSearchTable");
            }} />
        </Modal>

        <Modal
          title={this.internationalization.btn7}
          visible={this.state.seeParamsConfigVisible}
          footer={null}
          destroyOnClose
          width="1100px"
          onCancel={() => { this.modalVisibleAction("seeParamsConfigVisible", false); }}>
          <StubParamsConfig
            stubId={this.state.stubId}
            stubGroupName={this.state.stubGroupName}
            devType={this.state.devType} />
        </Modal>

        <Modal
          title={this.internationalization.wz7}
          visible={this.state.getFrameWorkVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => { this.modalVisibleAction("getFrameWorkVisible", false); }}>
          <GetFrameWorkEdition
            endModal={() => {
              console.log("GetFrameWorkEdition End");
              this.fetchApi(this.state.tableParam);
              this.modalVisibleAction("getFrameWorkVisible", false);
            }}
            stubId={this.state.stubId}
            onCancel={() => { this.modalVisibleAction("getFrameWorkVisible", false); }} />

        </Modal>
        <Modal
          title={this.internationalization.wz8}
          visible={this.state.frameWorkUpdateVisible}
          footer={null}
          destroyOnClose
          width="600px"
          onCancel={() => {
            this.modalVisibleAction("frameWorkUpdateVisible", false);
            console.log("init");
            // RefreshGrid(this.context.store, 'stubSearchTable', this.state.currentParam);
          }}>

          <FrameWorkUpdate
            updateFramType={() => { this.updateFramType(); }}
            frameWorkUpdateFunc={() => {
              this.fetchApi(this.state.tableParam);
              this.modalVisibleAction("frameWorkUpdateVisible", false);
              this.setState({
                progressVisible: true,
              });
            }}
            errorHandler={() => {
              this.modalVisibleAction("frameWorkUpdateVisible", false);
              this.setState({
                updateStatus: "error",
                progressVisible: true,
              });
            }}
            stubId={this.state.stubId}
            frameWork={this.state.frameWork}
            frameType={this.state.frameType}
            stubGroupName={this.state.stubGroupName}
            onCancel={() => { this.modalVisibleAction("frameWorkUpdateVisible", false); }}
            devType={this.state.devType} />
        </Modal>
        <Modal
          title="状态日志"
          visible={this.state.statusLogVisible}
          footer={null}
          destroyOnClose
          width="800px"
          onCancel={() => { this.modalVisibleAction("statusLogVisible", false); }}>
          <StubStatusLog stubIdData={this.stubInfoData && this.stubInfoData.key} />
        </Modal>

        <Modal
          visible={this.state.progressVisible}
          destroyOnClose
          footer={null}
          onCancel={() => { this.setState({ progressVisible: false }); }}
          title="升级进度"
            >
          <UpdateProgress record={this.stubInfoData} updateStatus={this.state.updateStatus} />
          <div style={{ textAlign: "center", marginTop: "24px" }}>
            <Button type="primary" onClick={() => this.setState({ progressVisible: false })}>隐藏</Button>

          </div>
        </Modal>
                      </div>;
      return Content;
    }
}

export default injectIntl(StubList);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/stubList.js